import { Button, Icon } from "@deligoo/ui"
import clsx from "clsx"
import { toast } from "react-toastify"

import { useAppSelector } from "@/App"
import { Card } from "@/components/Card"
import { PackageCard } from "@/components/PackageCard"
import { selectClientIdKey } from "@/store/clients"
import { OrderUtils } from "@/utils"

import { useManualOrderFormContext } from "../AddManualOrderView"
import cls from "../AddManualOrderView.module.scss"

export const RemainingView = () => {
  const { formState, setFormStateValue, setNextStep, setPreviousStep } = useManualOrderFormContext()

  function submitStep() {
    const { packages } = formState.values || {}

    const packagesCount = packages ? Object.values(packages).reduce((prev, curr) => Number(prev) + Number(curr), 0) : 0

    let errorsCount = 0

    toast.dismiss("packagingError")

    if (!packagesCount) {
      errorsCount++

      toast.error("Wybierz rodzaj zamówienia", {
        toastId: "packagingError",
        updateId: "packagingError",
      })
    }

    if (!errorsCount) setNextStep()
  }

  return (
    <Card className={cls.card}>
      <Card.Section>
        <h3>Wprowadź pozostałe dane</h3>
      </Card.Section>

      <Card.Section>
        <h2 className={clsx(cls.required, "pb-8")}>Rodzaj zamówienia</h2>
        <Packages />

        <h2 className="py-8">Uwagi do zamówienia</h2>

        <textarea
          name="description"
          placeholder="Uwagi do zamówienia"
          onChange={(e) => setFormStateValue({ order_comment_attributes: { description: e.currentTarget.value } })}
          defaultValue={formState.values.order_comment_attributes?.description}
        />
      </Card.Section>

      <Card.Section className={cls.submitBtns}>
        <Button
          className={cls.submitBtn}
          color="primary"
          variation="accented"
          size="extra-large"
          fullWidth
          onClick={setPreviousStep}
        >
          <Icon name="short-arrow-tiny-left" />
          Wstecz
        </Button>

        <Button className={cls.submitBtn} color="primary" size="extra-large" fullWidth onClick={submitStep}>
          Przejdź dalej
          <Icon name="short-arrow-tiny-right" />
        </Button>
      </Card.Section>
    </Card>
  )
}

const Packages = () => {
  const { formState, setFormStateValue } = useManualOrderFormContext()

  const clientId = formState.values.client_id!

  const clientInterfaceType = useAppSelector(selectClientIdKey(clientId, "interface_type"))

  return (
    <div className={cls.packages}>
      {OrderUtils.getInterfacePackageTypes(clientInterfaceType!).map((type) => (
        <PackageCard
          type={type}
          value={Number(formState.values?.packages?.[type]) || 0}
          setValue={(value) =>
            setFormStateValue?.({ packages: { ...(formState.values.packages || {}), [type]: value } })
          }
          key={type}
        />
      ))}
    </div>
  )
}
